var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { PartialRoute } from "@irati/utils/history/routing";
import { LangLoader } from "@irati/utils/lang";
import { ACCOUNT, ONBOARDING } from "@irati-web/app/src/routeConfig";
import { getQuery } from "../helpers/getOnboardingQuery";
import OnboardContainer from "../containers/OnboardContainer";
import RequestNewLink from "../containers/V2/RequestNewLink";
import MalformedLink from "../containers/MalformedLink";
import UserOnboarding from "../containers/V4/UserOnboarding";
var Routes = function () {
    var _a = getQuery(), token = _a.token, uuid = _a.uuid, code = _a.code;
    var Comp = UserOnboarding;
    // if we have a token, its a v2 url
    if (token) {
        Comp = RequestNewLink;
    }
    else if (!uuid || !code) {
        // if we don't have a uuid or code it's a malformed url
        Comp = MalformedLink;
    }
    return (React.createElement(LangLoader, { buckets: [ONBOARDING, ACCOUNT] },
        React.createElement(OnboardContainer, null,
            React.createElement(Comp, null))));
};
var Onboarding = /** @class */ (function (_super) {
    __extends(Onboarding, _super);
    function Onboarding() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Onboarding.prototype.render = function () {
        var path = this.props.path;
        return React.createElement(PartialRoute, { path: path, noauth: true, component: Routes });
    };
    return Onboarding;
}(Component));
export default Onboarding;
